import React from 'react';
export const AppConfigContext = /*#__PURE__*/React.createContext({});
const AppContext = /*#__PURE__*/React.createContext({
  message: {},
  notification: {},
  modal: {}
});
export default AppContext;